import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  Signal,
} from '@angular/core';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { TablePageChangeEvent } from '../../events/table-page-change.event';
import { isNil } from '@web/utils';

@Component({
  selector: 'app-table-paginator',
  imports: [PaginatorModule],
  templateUrl: './table-paginator.component.html',
  styleUrls: ['./table-paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TablePaginatorComponent {
  public readonly first = input.required<number>();
  public readonly rows = input.required<number>();
  public readonly total = input.required<number>();
  public readonly pageChange = output<TablePageChangeEvent>();

  protected readonly stats = this.statsSignal();

  public statsSignal(): Signal<string> {
    return computed(() => {
      const first = this.total() > 0 ? this.first() + 1 : 0;
      const last = Math.min(this.first() + this.rows(), this.total());
      const total = this.total();

      return `Pozycje ${first} - ${last} z ${total}`;
    });
  }

  public handlePageChange(event: PaginatorState): void {
    const { page, first, rows, pageCount } = event;

    if (isNil(page) || isNil(first) || isNil(rows) || isNil(pageCount)) {
      return;
    }

    this.pageChange.emit(
      new TablePageChangeEvent(page, first, rows, pageCount),
    );
  }
}
